const ActiveItemProperties = ({ properties }) => {
  const getPropsStyle = () => {
    if (properties.length === 3) return "card-details__card--properties-short";
    if (properties.length % 2 === 1)
      return "card-details__card--properties-odd";
  };

  return (
    <section
      className={`card-details__card card-details__card--properties ${getPropsStyle()}`}
    >
      <h3 className="card-details__title">Properties</h3>
      <ul className="card-details__prop-list">
        {properties.map((prop) => {
          if (prop.title !== '' && prop.text !== '') {
            return (
              <li key={prop.title} className={`card-details__prop-list-item`}>
                <span title={prop.title}>{prop.title}</span>
                <b title={prop.text}>{prop.text}</b>
              </li>
            );
          } else return null;
        })}
      </ul>
    </section>
  );
};

export default ActiveItemProperties;
